export const mapListItemToOption = item => ({
  value: item.id,
  label: item.name,
});



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfilePaymentMethods/OrganizationPopup/utils/map-list-item-to-option.js